// Importar todas as logos de integrações - Vite precisa de imports explícitos
import activecampaignImg from './activecampaign.jpeg';
import botconversaImg from './botconversa.jpeg';
import builderallImg from './builderall.png';
import leadloversImg from './leadlovers.jpeg';
import logoSmsFunnelImg from './logo-smsfunnel.png';
import metaImg from './meta.png';
import newzaprapidoImg from './newzaprapido.png';
import notificacoesInteligentesImg from './NotificacoesInteligentes.png';
import sellfluxImg from './sellflux.jpeg';
import voxyuImg from './voxyu.jpeg';

export const integrationLogos = {
  activecampaign: activecampaignImg,
  'bot-conversa': botconversaImg,
  botconversa: botconversaImg,
  builderall: builderallImg,
  leadlovers: leadloversImg,
  'logo-smsfunnel': logoSmsFunnelImg,
  smsfunnel: logoSmsFunnelImg,
  meta: metaImg,
  'meta-pixel': metaImg,
  'zapp-rapido': newzaprapidoImg,
  newzaprapido: newzaprapidoImg,
  'notificacoes-inteligentes': notificacoesInteligentesImg,
  notificacoesInteligentes: notificacoesInteligentesImg,
  sellflux: sellfluxImg,
  voxuy: voxyuImg,
  voxyu: voxyuImg,
};

export default integrationLogos;
